import LearningExperienceBox from './LearningExperienceBox';

export default LearningExperienceBox;
